export const home = {
  // Hero Section
  hero: {
    title: 'WHERE VISION\nBECOMES FORM',
    subtitle: 'CRAFTED EXCELLENCE SINCE INCEPTION',
  },
  
  // Welcome Statement
  welcome: {
    text: 'Welcome to the world of LUCENDO — where vision becomes form and quality becomes identity. Our home is a place of innovation, creativity, and meticulous production. Ideas are transformed into exceptional products through expertise, technology, and refined aesthetics. From concept to completion, every step is guided by precision and care.',
  },
  
  // Brand Pillars
  pillars: {
    whoWeAre: {
      title: 'WHO WE ARE',
      intro: 'At LUCENDO, luxury is not a promise — it is a standard.',
      paragraph1: 'We are a brand driven by precision, craftsmanship, and an uncompromising commitment to quality. Born from a deep understanding of modern elegance and timeless values, Lucendo exists to create products that inspire confidence, elevate everyday experiences, and reflect refined taste.',
      paragraph2: 'Every detail we touch is intentional. Every product we create carries our philosophy: excellence without excess, sophistication without compromise, and beauty rooted in authenticity.',
    },
    vision: {
      title: 'VISION',
      paragraph1: 'To become a globally respected luxury brand recognized for excellence, integrity, and innovation.',
      paragraph2: 'LUCENDO envisions a future where premium quality is accessible to brands and customers who value distinction. We aim to set new benchmarks in private label and production standards, shaping the future of luxury with responsibility, creativity, and purpose.',
    },
    mission: {
      title: 'MISSION',
      paragraph1: 'Our mission is to deliver superior products that embody elegance, reliability, and performance.',
      paragraph2: 'We are committed to:',
      commitments: [
        'Crafting products that meet the highest international quality standards',
        'Building long-term partnerships based on trust and transparency',
        'Continuously innovating while respecting craftsmanship and detail',
        'Creating value that goes beyond aesthetics — delivering real substance',
      ],
      closing: 'At LUCENDO, success is measured not only by growth, but by the lasting impression we leave.',
    },
  },
  
  // Closing Statement
  closing: {
    quote: '"At LUCENDO, success is measured not only by growth, but by the lasting impression we leave."',
  },
};
